import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";
export class InvisilatorService {
  static async getInvisilatorByExam(examId: string) {
    return await makeRequest(
      url.invigilator.getAllByExam(examId),
      RequstMethods.GET,
    );
  }
  static async getInvigilatorById(invigilatorId: string) {
    return makeRequest(
      url.invigilator.getDetails(invigilatorId),
      RequstMethods.GET,
    );
  }

  static async createInvigilator(payload: any) {
    return makeRequest(url.invigilator.create, RequstMethods.POST, payload);
  }

  static async updateInvigilator(invigilatorId: string, payload: any) {
    return makeRequest(
      url.invigilator.update(invigilatorId),
      RequstMethods.PUT,
      payload,
    );
  }
  static async updateInvigilatorStatus(invigilatorId: string, payload: any) {
    return makeRequest(
      url.invigilator.updateStatus(invigilatorId),
      RequstMethods.PUT,
      payload,
    );
  }

  static async resetPassword(invigilatorId: string, payload: any) {
  return makeRequest(
    url.invigilator.resetPassword(invigilatorId),RequstMethods.PUT,payload
  );
}

static async deleteInvigilator(invigilatorId: string) {
  return makeRequest(
    url.invigilator.delete(invigilatorId),RequstMethods.DELETE
  );
}

static async getAllUsers(pageNumber = 1, pageSize = 50, search) {
  return makeRequest(
    url.users.getAll(pageNumber, pageSize,search),RequstMethods.GET
  );
}

static async assignStudents(invigilatorId: string, payload: any) {
  return makeRequest(
    url.invigilator.assignStudents(invigilatorId),
    RequstMethods.PUT,
    payload
  );
}
static async getAssignedStudents(invigilatorId: string) {
  return makeRequest(
    url.invigilator.getAssignedStudents(invigilatorId),RequstMethods.GET
  );
}






}
